import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faClock,
  faSortUp,
  faSortDown,
  faSquare,
  faCheckSquare,
  faCircle,
  faCheckCircle,
  faMinusCircle,
  faPlusCircle,
  faInfoCircle,
  faTimes,
  faArrowsAltV,
  faEnvelope,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faLink,
  faUnlink,
  faExclamationTriangle,
  faQuestionCircle,
  faCheck,
  faDatabase,
  faBars,
  faCaretLeft,
  faCaretRight,
  faCloudUploadAlt,
  faPlayCircle,
  faPauseCircle,
  faTimesCircle,
  faImage,
  faSave,
  faMobileAlt,
} from '@fortawesome/free-solid-svg-icons'

import {
  faToggleOn,
  faToggleOff,
  faEye,
  faPrint,
  faCopy,
  faComments,
  faTrash,
  faSignOutAlt,
  faClone,
  faUserFriends,
  faSortAmountDownAlt,
  faUser,
  faUserTie,
  faMehBlank,
  faPen,
  faHistory,
  faAddressCard,
  faFileExcel,
  faFileWord,
  faCamera,
  faImagePolaroid,
} from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faClock,
  faBold,
  faSortUp,
  faSortDown,
  faToggleOn,
  faToggleOff,
  faEye,
  faPrint,
  faCopy,
  faComments,
  faTrash,
  faSignOutAlt,
  faSquare,
  faCheckSquare,
  faCircle,
  faCheckCircle,
  faMinusCircle,
  faPlusCircle,
  faInfoCircle,
  faTimes,
  faArrowsAltV,
  faEnvelope,
  faItalic,
  faUnderline,
  faStrikethrough,
  faLink,
  faUnlink,
  faExclamationTriangle,
  faQuestionCircle,
  faCheck,
  faClone,
  faUserFriends,
  faSortAmountDownAlt,
  faUser,
  faUserTie,
  faMehBlank,
  faDatabase,
  faPen,
  faBars,
  faHistory,
  faAddressCard,
  faCaretLeft,
  faCaretRight,
  faCloudUploadAlt,
  faPlayCircle,
  faPauseCircle,
  faTimesCircle,
  faFileExcel,
  faFileWord,
  faSave,
  faCamera,
  faImage,
  faImagePolaroid,
  faMobileAlt,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)